export enum DeviceLastActiveTimeframe {
  NotActive = "Not Active",
  SevenDays = "> 7 days ago",
  FourteenDays = "> 14 days ago",
  ThirtyDays = "> 30 days ago",
  Unknown = "Unknown",
}